import * as React from "react";
import { GridSidebarComparisonList } from "./list";
import { GridSidebarComparisonForm } from "@/modules/snapshots/grid/sidebar/comparison/form";
import { useAppSelector } from "@/store/hooks";
import { selectCompareResults } from "@/store/slices/snapshotCompareSlice";
import { GridSidebarComparisonResponse } from "@/modules/snapshots/grid/sidebar/comparison/response";

export const GridSidebarComparison: React.FC = () => {
  const [conversationId, setConversationId] = React.useState<string>();
  const results = useAppSelector(selectCompareResults);

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-y-auto p-4">
      <GridSidebarComparisonList />
      {results.length > 1 && (
        <>
          <GridSidebarComparisonForm setConversationId={setConversationId} />
          {!!conversationId && <GridSidebarComparisonResponse conversationId={conversationId} />}
        </>
      )}
    </div>
  );
};
